import { PartialTranslation } from '../translations';

export const te: PartialTranslation = {
  newChat: 'కొత్త చాట్',
  search: 'వెతకండి',
  user: 'వినియోగదారు',
  settings: 'సెట్టింగులు',
  language: 'భాష',
  getHelp: 'సహాయం పొందండి',
  viewAllPlans: 'అన్ని ప్లాన్‌లను చూడండి',
  learnMore: 'మరింత తెలుసుకోండి',
  logOut: 'లాగ్ అవుట్',
  chooseLanguage: 'భాషను ఎంచుకోండి',
  chooseYourPreferredLanguage: 'మీకు ఇష్టమైన భాషను ఎంచుకోండి',
  searchLanguages: 'భాషలను వెతకండి...',
  autoDetect: 'స్వయంచాలక గుర్తింపు',
  noLanguagesFound: 'భాషలు కనుగొనబడలేదు',
  askAnything: 'ఏదైనా అడగండి',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'వ్యక్తిగత',
  freePlan: 'ఉచిత ప్లాన్',
  current: 'ప్రస్తుత',
  close: 'మూసివేయండి',
  archive: 'ఆర్కైవ్',
  delete: 'తొలగించండి',
  confirmDelete: 'మీరు ఖచ్చితంగా ఈ చాట్‌ను తొలగించాలని అనుకుంటున్నారా?',
  confirmArchive: 'మీరు ఖచ్చితంగా ఈ చాట్‌ను ఆర్కైవ్ చేయాలని అనుకుంటున్నారా?',
  deleteCannotUndo: 'ఈ చర్యను రద్దు చేయలేరు.',
  archiveCanFind: 'ఆర్కైవ్ చేసిన తర్వాత మీరు దాన్ని ఆర్కైవ్ లిస్ట్‌లో కనుగొనవచ్చు.',
  // 资源面板
  resources: 'వనరులు',
  addResource: 'వనరును జోడించండి',
  deleteResource: 'వనరును తొలగించండి',
  noMatchingResourcesFound: 'సరిపోలే వనరులు కనుగొనబడలేదు',
  noResourcesAvailable: 'వనరులు అందుబాటులో లేవు',
  hideResources: 'వనరులను దాచండి',
  showResources: 'వనరులను చూపించండి',
  
  // 聊天输入框
  typeMessage: 'సందేశాన్ని టైప్ చేయండి...',
  thinkingOptions: 'ఆలోచన ఎంపికలు',
  deleteFile: 'ఫైల్‌ను తొలగించండి',
  clearSelection: 'ఎంపికను క్లియర్ చేయండి',
  
  // 思考模式选项
  deepInsight: 'లోతైన అంతర్దృష్టి · ఉపరితల విశ్లేషణ',
  deepInsightDesc: 'కీలక అంశాల త్వరిత అవగాహన',
  deepExploration: 'లోతైన అన్వేషణ · సమగ్ర విశ్లేషణ',
  deepExplorationDesc: 'బహుమితీయ లోతైన పరిశోధన',
  deepDeconstruction: 'లోతైన విధ్వంసం · వ్యవస్థాపిత వాదన',
  deepDeconstructionDesc: 'పొరల వారీగా ప్రగతిశీల విశ్లేషణ',
  
  // 写作模式选项
  contractReview: 'ఒప్పంద సమీక్ష · రిస్క్ గుర్తింపు',
  contractReviewDesc: 'నిబంధన విశ్లేషణ మరియు అనుపాలన తనిఖీ',
  textPolish: 'టెక్స్ట్ పాలిష్ · వృత్తిపరమైన వ్యక్తీకరణ',
  textPolishDesc: 'భాష ఆప్టిమైజేషన్ మరియు నిర్మాణ సర్దుబాటు',
  legalDocuments: 'చట్టపరమైన పత్రాలు · ప్రామాణిక ముసాయిదా',
  legalDocumentsDesc: 'వృత్తిపరమైన చట్టపరమైన పత్రం రచన',
  addAttachment: 'అటాచ్‌మెంట్ జోడించండి',
  sendMessage: 'సందేశాన్ని పంపండి',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'లాగిన్',
  register: 'నమోదు',
  welcomeBack: 'LawHelper కు స్వాగతం',
  loginSubtitle: 'మీ AI న్యాయ పరిశోధన సహాయకుడు',
  continueWithGoogle: 'Google తో కొనసాగించు',
  continueWithMicrosoft: 'Microsoft తో కొనసాగించు',
  continueWithWeChat: 'WeChat తో కొనసాగించు',
  orContinueWith: 'లేదా దీనితో కొనసాగించు',
  emailTab: 'ఇమెయిల్',
  phoneTab: 'ఫోన్',
  emailPlaceholder: 'మీ ఇమెయిల్ నమోదు చేయండి',
  phonePlaceholder: 'ఫోన్ నంబర్ నమోదు చేయండి',
  codePlaceholder: '6 అంకెల కోడ్ నమోదు చేయండి',
  sending: 'పంపుతోంది...',
  verifying: 'ధృవీకరిస్తోంది...',
  verify: 'ధృవీకరించు',
  sendMagicLink: 'మాజిక్ లింక్ పంపు',
  getVerificationCode: 'కోడ్ పొందు',
  resendCode: 'కోడ్ మళ్ళీ పంపు',
  resendIn: 'మళ్ళీ పంపు',
  magicLinkSent: 'మాజిక్ లింక్ మీ ఇమెయిల్‌కు పంపబడింది',
  magicLinkHint: 'మీ ఇమెయిల్‌కు సురక్షిత లింక్ పంపుతాము',
  otpSent: 'ధృవీకరణ కోడ్ పంపబడింది',
  agreeToTerms: 'కొనసాగించడం ద్వారా, మీరు అంగీకరిస్తున్నారు',
  privacyPolicy: 'గోప్యతా విధానం',
  termsOfService: 'సేవా నిబంధనలు',
  and: 'మరియు',
  privacyTitle: 'మీ గోప్యత ముఖ్యమైనది',
  privacyIntro: 'మీకు అత్యుత్తమ అనుభవాన్ని అందించడానికి కుకీలు మరియు సారూప్య సాంకేతికతలను ఉపయోగిస్తున్నాము.',
  essentialCookies: 'అవసరమైన కుకీలు',
  essentialDesc: 'వెబ్‌సైట్ పనిచేయడానికి అవసరం',
  analyticsCookies: 'విశ్లేషణ కుకీలు',
  analyticsDesc: 'మా సేవను మెరుగుపరచడంలో సహాయపడుతుంది',
  marketingCookies: 'మార్కెటింగ్ కుకీలు',
  marketingDesc: 'వ్యక్తిగతీకరించిన కంటెంట్ కోసం ఉపయోగించబడుతుంది',
  acceptAll: 'అన్నీ అంగీకరించు',
  essentialOnly: 'అవసరమైనవి మాత్రమే',
  customize: 'అనుకూలీకరించు',
  savePreferences: 'ప్రాధాన్యతలను సేవ్ చేయండి',
  back: 'వెనక్కి',
  readPrivacyPolicy: 'మా గోప్యతా విధానాన్ని చదవండి',
  cookiePolicy: 'కుకీ విధానం',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI సమీక్ష',
  aiDraft: 'AI డ్రాఫ్ట్',
  smartAssistant: 'టెంప్లేట్',

  // 知识库搜索
  enableKnowledgeSearch: 'శోధన ప్రారంభించు',
  knowledgeSearchDesc: 'AI మీ పత్రాలలో శోధిస్తుంది',
  clickToDisable: 'నిలిపివేయి',
  clickToEnable: 'ప్రారంభించు',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Close Resources Panel',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'త్వరిత సమాధానం',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'రద్దు చేయి',
  library: 'గ్రంధాలయం',
  filterAll: 'అన్నీ',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'ఆలోచిస్తున్నాను...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Service Error',
  uploaded: 'Uploaded',
  settingsGeneral: 'సాధారణ',
  settingsNotifications: 'Notifications',
  settingsAppearance: 'Appearance',
  settingsProfile: 'Profile',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Light',
  settingsDark: 'Dark',
  settingsSystem: 'System',
  about: 'గురించి',
  reviewTitle: 'Document Review',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Reviewing...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Legal Document Drafting',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Generating...',
  generatedSuccess: '✅ Document generated! You can view and edit in the editor.',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'History',
  drafterNoHistory: 'No history yet',
  drafterNewChat: 'New Chat',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Save Document',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Exit',
  drafterConfirm: 'Confirm',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Ready',
  workflowCompleted: 'Completed',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Stop',
  restartWorkflow: 'Restart',
  startDrafting: 'Start Drafting',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Contract',
  docTypeAgreement: 'Agreement',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Letter',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'స్మార్ట్ డాక్యుమెంట్ సహాయకుడు',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'లోపం',
  unknownError: 'Unknown error',
  file: 'ఫైల్',
  loading: 'లోడ్ అవుతున్నది...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI విశ్లేషణ',
};
